<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row v-if="props.mode == 'List'">
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>
    </b-row>
    <b-row v-if="props.mode == 'User'">
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
    </b-row>

    <b-row v-if="props.mode == 'UserModal'">
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <!-- <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col> -->
      <b-col cols="12" md="6" >
        <b-form-group
          label="ชื่อหน่วยงาน (ในระบบ portal)"
          label-for="departmentObj"
        >
          <v-select
            label="text"
            v-model="departmentObj"
            :options="departmentObjs"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- <b-row v-if="props.mode == 'CancelSecretary'">
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
    </b-row> -->

    <div v-if="props.mode != 'CancelSecretary'">
      <!-- Action Buttons -->
      <div class="text-center pt-1">
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          type="submit"
        >
          ค้นหา
        </b-button>
        <b-button
          variant="outline-secondary"
          type="reset"
          @click="onResetBtnClicked"
        >
          ล้าง
        </b-button>
      </div>
    </div>

  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as departmentStore from "@/store/api/department/index.js";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
    autoSearch: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    let departmentObjs =[{ text: "ชื่อหน่วยงาน (ในระบบ portal)", value: "" }];
    const options = [
      { text: "ทั้งหมด", value: null },
      { text: "ใช้งาน", value: true },
      { text: "ไม่ใช้งาน", value: false },
    ];

    const searchList = [
      {
        id: "text",
        label: "คำค้นหา",
        value: "",
        class: "",
        style: "",
        placeholder: "คำค้นหา",
        type: "text",
        options: [],
      },
      {
        id: "isActive",
        label: "สถานะการใช้งาน",
        value: "",
        class: "",
        style: "",
        placeholder: "สถานะการใช้งาน",
        type: "select",
        options,
      },
      // {
      //   id: "portalDepartmentName",
      //   label: "ชื่อหน่วยงาน (ในระบบ portal)",
      //   value: "",
      //   class: "",
      //   style: "",
      //   placeholder: "ชื่อหน่วยงาน (ในระบบ portal)",
      //   type: "select",
      //   options: departmentObj,
      // },
    ];

    return {
      options,    
      departmentObjs,
      departmentObj:{
        text: "ชื่อหน่วยงาน (ในระบบ portal)",
        value: departmentObjs.value,
      },
      search: searchList,
      props,
    };
  },
  mounted() {
    this.getDepartment();
    console.log("autoSearch", this.autoSearch, this.props);
    if (this.autoSearch === true) {
      this.onSearchBtnClicked();
    }
  },
  methods: {
    getDepartment(){
      const _this = this;
      var setDataList = [];
      const params = {
          name: "",
          isActive: null,
        };
      departmentStore
        .searchdepartmentinternal(params)
        .then(function(response) {
          // handle success


          _this.departmentObjs = response.data.data;
          console.log("1",_this.departmentObjs);
          _this.departmentObjs.forEach((o) => {
            var setData = {};
            setData.value = o.name;
            setData.text = o.name;

            setDataList.push(setData);
          });

          const departmentObjUnique = [
            ...new Map(
              setDataList.map((item) => [item["value"], item])
            ).values(),
          ];

          //_this.officers.push(...setDataList);
          _this.departmentObjs = departmentObjUnique;

          _this.$forceUpdate();
          console.log("2",_this.departmentObjs);
        },)
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    selectOnInput() {
      this.$forceUpdate();
    },
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
    },
    onSearchBtnClicked() {
      if (this.mode === "List") {
        const params = {
          name: this.search[0].value,
          isActive: this.search[1].value,
        };
        this.$emit("handleSubmit", params);
      } else if (this.mode === "User") {
        const params = {
          name: this.search[0].value,
        };
        this.$emit("handleSubmit", params);
      } else if (this.mode === "UserModal") {
        const params = {
          name: this.search[0].value,
          portalDepartmentName: this.departmentObj.value,
        };
        this.$emit("handleSubmit", params);
      } else if (this.mode === "CancelSecretary") {
        const params = {
          name: this.search[0].value,
        };
        this.$emit("handleCancelSubmit", params);
      }

      //console.log('onSearchBtnClicked', params)
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
